<template>
  <section class="relative">
    <section
      class="h-full w-full bg-skin-primary-findrisk bg-opacity-20 fixed z-20 top-0 right-0 left-0 flex justify-center"
    >
      <section
        class="overflow-y-auto light-scroll h-screen w-screen max-w-360 grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12 gap-x-4 md:gap-x-6 py-20"
      >
        <section
          class="col-span-full md:col-start-2 md:col-end-8 lg:col-start-4 lg:col-end-10 flex flex-col justify-center md:px-12"
        >
          <section
            class="w-full rounded-2xl bg-white pl-6 md:pl-12 pr-12px pb-6 md:pb-12 pt-12px"
          >
            <section class="w-full flex justify-end pb-20px">
              <button
                class="focus:outline-none"
                @click="changeShowModal(false)"
              >
                <icon
                  :name="'close'"
                  :width="26"
                  :height="26"
                  :color="'black'"
                />
              </button>
            </section>
            <data-form :personData="data" @close="onClose" />
          </section>
        </section>
      </section>
    </section>
  </section>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_NAME_COMPONENTS } from "../store/modules/components";
export default {
  name: "FormModal",
  components: {
    Icon: () => import("./Icon.vue"),
    DataForm: () => import("./DataForm.vue")
  },
  props: {
    data: {
      default: null,
    },
  },
  methods: {
    ...mapActions(STORE_NAME_COMPONENTS, ["changeShowModal"]),
    onClose(_payload){
      this.$emit("close", _payload)
    }
  },
  computed: {
    ...mapGetters(STORE_NAME_COMPONENTS, ["showModal"]),
  },
};
</script>
